import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { IconPaths } from '_metronic/helpers'
import { RowActions } from 'app/components'
import { AtendimentoList } from 'app/modules/apps/atendimento/core/_models'

type Props = {
  atendimento: AtendimentoList
}

export const LogsConsultaActionsCell: FC<Props> = ({ atendimento }) => {
  const navigate = useNavigate()

  return (
    <RowActions
      itemName={atendimento.protocolo ? `atendimento ${atendimento.protocolo}` : 'atendimento'}
      primaryAction={{
        label: 'Ver logs',
        icon: IconPaths.Search,
        onClick: () => navigate(`/apps/admin/logs/consulta/${atendimento.id}`),
      }}
    />
  )
}
